import Big from 'big.js'

export function dollarToCents(amountInDollar: Dollars | string) {
  const sanitizedValue = amountInDollar.toString().replace(/[$,–]/g, '')
  const isValidValue = sanitizedValue !== '' && sanitizedValue !== '-'

  return (isValidValue ? Big(sanitizedValue).times(100).toNumber() : 0) as Cents
}
